import { render, staticRenderFns } from "./ChinaMap.vue?vue&type=template&id=8d469ab2&scoped=true"
import script from "./ChinaMap.vue?vue&type=script&lang=js"
export * from "./ChinaMap.vue?vue&type=script&lang=js"
import style0 from "./ChinaMap.vue?vue&type=style&index=0&id=8d469ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d469ab2",
  null
  
)

export default component.exports